import React from 'react';

export default function ChatMessage({ message }) {
  const isUser = message.role === 'user';
  const isError = message.isError;

  return (
    <div className={`flex ${isUser ? 'justify-end' : 'justify-start'}`}>
      <div
        className={`max-w-[85%] rounded-lg p-4 ${
          isUser
            ? 'bg-gray-100 text-gray-900'
            : isError
            ? 'bg-red-50 text-red-700 border border-red-200'
            : 'bg-ia bg-opacity-10 text-gray-900'
        }`}
      >
        {!isUser && (
          <span className="text-lg mr-2">🤖</span>
        )}
        <span className="whitespace-pre-wrap">{message.content}</span>
        {message.isStreaming && (
          <span className="inline-block w-2 h-4 bg-ia ml-1 animate-pulse" />
        )}
      </div>
    </div>
  );
}
